import React, { useState, useEffect, Fragment } from "react";
import styles from "./styles.module.css";
import Head from "next/head";
import Script from 'next/script';
import { PagegrowlerFunctions, PagegrowlerInstance } from "@pagegrowler_nextjs";

import TagManager from "react-gtm-module";
import getDataLayer from "@/shared/functions/gtm";
import getFormatedDate from "./components/functions/getFormatedDate";
import Ldjson from './components/functions/Ldjson';
import LdJsonLiveblogs from './components/Liveblogs/components/LdJsonLiveblogs'

import Header from "@/shared/components/Header";
import Footer from "@/shared/components/Footer";
import Chartbeat from '@/shared/components/Chartbeat';

import Video from './components/Video/index.js';
import Author from "./components/Author";
import Nameplate from "./components/Nameplate";
import NotasRelacionadas from "./components/NotasRelacionadas";
import Img from "./components/Img";
import SocialLinks from './components/Social/index.js';
import EmbedGallery from './components/EmbedGallery/index.js';
import DataFactory from "./components/DataFactory";
import { Liveblogs } from './components/Liveblogs';
import FreeHtml from "./components/FreeHtml";

import Templates from '@/widgets/index';
import AdemasTenes from "@/widgets/Listado/Templates/AdemasTenes";
import Suscribite from '@/widgets/Misc/Templates/Suscribite';
import AdemasTenesQueLeer from "@/widgets/Listado/Templates/AdemasTenesQueLeer";
import MegaBannerDerecha from '@/shared/components/MegaBannerDerecha'
import { getImageFromClippingList } from "@/shared/functions/getImagesFunctions";

import DateTimeUpdateComponent from "./components/DateTimeUpdate";
import Slider from "@/shared/components/Slider";
import ExpandImage from "@/icons/components/ExpandImage";
import PagegrowlerList from "@/widgets/Listado/Templates/PagegrowlerList";

function Nota(props) {
    const [components, setComponents] = useState()
    const [showSlider, setShowSlider] = useState(false);
    const [currentSlide, setcurrentSlide] = useState(0);

    const RELATED_CLIPPING = "2_1_1300x655";
    const CONTENT_CLIPPING = "3_2_870x580";
    const LILANEWS_CLIPPING = "3_2_248x166";

    const CONTENT_CLIPPING_SLIDER = '2_1_1300x655';

    const RELATED_PROPS = {
        clippings: [RELATED_CLIPPING],
        domain: process.env.NEXT_PUBLIC_IMAGE_DOMAIN,
    };

    const [open, setOpen] = useState(false);

    let menues = props.menu ? props.menu : [];

    const Pagegrowler = PagegrowlerInstance();
    /* const pagegrowlerFunctions = PagegrowlerFunctions(); */

    const {
        _id,
        title,
        summary,
        body,
        authors,
        publishedDate,
        modificatedAt,
        lastModified,
        related,
        sections,
        gtm_name,
        url,
        tags,
        subtitle,
        metadata,
        keywords
    } = { ...props.content };

    let zuluPublishedDate;
    let zuluModificatedAt;

    try {
        zuluPublishedDate = new Date(publishedDate).toISOString();
        zuluModificatedAt = new Date(modificatedAt).toISOString();
      } catch (e) {
        zuluPublishedDate = new Date().toISOString();
        zuluModificatedAt = new Date().toISOString();
      }
    
    const isLiveBlogs = body && body.find(el => el.type === 'liveblog') 
    
    const relatedNews = props.content && props.content.related ? props.content.related.lilanews : [];
    const relatedDataFactory = props.content && props.content.related && props.content.related.datafactory ? props.content.related.datafactory : [];
    const typeDatafactory = { domain: process.env.NEXT_PUBLIC_DATAFACTORY_IFRAME_URL };
    const widgets = { ...props.widgets };

    const TYPE_PROPS = [
        {
            type: "liveblog",
            template: Liveblogs,
            url: url
        },
        {
            type: "text",
            classes: `text-content ${styles["paragraph-detail"]} ${styles["lila-links"]} ${styles["note-styles"]}`,
            template: undefined,
        },
        {
            type: "freehtml",
            classes: `text-content ${styles['free-html-content']} ${styles["paragraph-detail"]}`,
            template: FreeHtml,
        },
        {
            type: "image",
            classes: `${styles["note-image"]}`,
            template: Img,
            clippings: [CONTENT_CLIPPING],
            domain: process.env.NEXT_PUBLIC_IMAGE_DOMAIN,
        },
        {
            type: "lilanews",
            classes: `${styles["paragraph-detail"]}`,
            template: NotasRelacionadas,
            clippings: [LILANEWS_CLIPPING],
            domain: process.env.NEXT_PUBLIC_IMAGE_DOMAIN,
        },
        {
            type: "embed",
            classes: `embed-content ${styles["paragraph-detail"]}`,
            template: undefined,
        },
        {
            type: "datafactory",
            classes: `data-factory-content ${styles["paragraph-detail"]}`,
            template: DataFactory,
            domain: process.env.NEXT_PUBLIC_DATAFACTORY_IFRAME_URL,
        },
        {
            type: 'video',
            classes: `video-content ${styles['paragraph-detail']}`,
            template: Video
        },
        {
            type: "gallery",
            classes: ``,
            template: EmbedGallery,
            clippings: [CONTENT_CLIPPING],
            domain: process.env.NEXT_PUBLIC_IMAGE_DOMAIN
        }
    ];

    const gtmObject = {
        _id: _id,
        publishedDate: publishedDate,
        page_type: "nota",
        nsSite:
            sections !== undefined && sections.length > 0
                ? sections[0].nsSite
                : "",
        gtm_name: gtm_name,
    };

    useEffect(() => {
        TagManager.dataLayer(getDataLayer(gtmObject));
        setComponents(props.widgets);
        let textQuote = document.querySelector('.article .custom-text blockquote');

        if (textQuote) {
            let lastLetterQuote = textQuote.innerHTML.length - 1;
            textQuote.innerHTML = textQuote.innerHTML.slice(0, 2)
                + '<span>' +
                textQuote.innerHTML.slice(2, -1)
                + '</span>' +
                textQuote.innerHTML[lastLetterQuote];
        }
    }, []);

    const isModifiedAfterPublish = new Date(modificatedAt).getTime() >= new Date(publishedDate).getTime();

    const rawModificatedDate = getFormatedDate(isModifiedAfterPublish ? modificatedAt : publishedDate);
    const rawPublishedDate = getFormatedDate(publishedDate);

    const publishedMonthDayYear = `${rawPublishedDate.weekday} ${rawPublishedDate.day}.${rawPublishedDate.month}.${rawPublishedDate.year}`;
    const publishedTimeHour = `${rawPublishedDate.hour}:${rawPublishedDate.minutes}`;
    const modificatedMonthDayYear = `${rawModificatedDate.weekday} ${rawModificatedDate.day}.${rawModificatedDate.month}.${rawModificatedDate.year}`;
    const modificatedTimeHour = `${rawModificatedDate.hour}:${rawModificatedDate.minutes}`;

    const content = Pagegrowler.getLilanewsParsedBody(body, TYPE_PROPS);

    const [temasPosition, setTemasPosition] = useState(-1);

    const tagTemasArrayLength = tags.length;
    const minimumTemasItems = tagTemasArrayLength - 6;

    const metaAuthor = authors && authors.length > 0 ? authors[0].name : 'Ellitoral.com';

    let ampUrl = url.replace('.html', '.amp.html');
    let sectionsUrlArray = '';
	let sectionUrl = url.split('/');
sectionsUrlArray = sectionUrl;
    sectionUrl.pop();
    sectionUrl = "/seccion" + sectionUrl.join('/');
    let summaryWithoutHtml = summary ? summary.replace(/(<([^>]+)>)/gi, "") : '';
    const metaDescription = metadata && metadata.metaDescription || summaryWithoutHtml;
    const metaTitle = metadata && metadata.title || title;

    let relatedImages = (related.images && related.images.length > 0 && related.images[0].value) ? getImageFromClippingList(related.images[0].value.clippings, RELATED_CLIPPING) : { domain: '', imgUrl: '' };
    const metaImageDefault = 'https://img-ellitoral.lilax.io/collections/utiles-diseno/generica-redes-1___6273ea8aae16950017079e88.jpg'
    
    const handleStyles = (index) => {
        if (index <= temasPosition && index <= minimumTemasItems) {
            return `${styles['temas-hidden']}`;
        } else {
            return `${styles['temas-text']}`;
        }
    };
    
    const image = Pagegrowler.getLilanewsRelatedContent(related, RELATED_PROPS, `${styles['article-image-epi']}`)

    const contentImages = content?.filter(item => item.type === 'image').map((item, index) => ({
        ...item,
        id: item.component.props.paragraph._id
    }));

    const imagesGallery = contentImages
    ? contentImages.reduce((acc, element) => {
        const imageClipping = getImageFromClippingList(element.component.props.paragraph.value.clippings, CONTENT_CLIPPING_SLIDER);
        const url = imageClipping ? imageClipping.domain + imageClipping.imgUrl : '';
        const epigraphe = element.component.props.paragraph.epigraphe || '';
  
        return [
          ...acc,
          { url, epigraphe, id: element.id }
        ];
      }, [{
        url: relatedImages.domain + relatedImages.imgUrl,
        epigraphe: related.images && related.images.length > 0 ? related.images[0]?.epigraphe : '',
        id: 0
      }])
    : [];
  


    const handleClickImage = (id) => {
        if (!id || id === 0 && imagesGallery.length !== 0) {
            setcurrentSlide(imagesGallery[0]?.id);
            setShowSlider(true);
        } else {
            const contentIndex = contentImages?.findIndex(item => item.id === id);
            setcurrentSlide(contentIndex + 1);
            setShowSlider(true);
        }
    };

    const handleCloseSlider = () => {
        setShowSlider(false);
        setcurrentSlide(false);
    };

    return (
        <>

            <Head>
                <title>{title}</title>
                {keywords && <meta property="keywords" content={keywords} />}
                {keywords && <meta property="news_keywords" content={keywords} />}
                <meta property="og:url" content={'https://www.ellitoral.com' + url} />
                <meta property="og:type" content="article" />
                <meta property="og:title" content={title} />
                <meta property="og:description" content={summaryWithoutHtml} />
                <meta property="og:image" content={!relatedImages.imgUrl ? metaImageDefault : relatedImages.domain + relatedImages.imgUrl} />
                <meta httpEquiv="refresh" content="3000" />
                <meta name="author" content={metaAuthor} />
                <meta name="title" content={metaTitle} />
                <meta name="description" content={metaDescription} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:image" content={!relatedImages.imgUrl ? metaImageDefault : relatedImages.domain + relatedImages.imgUrl} />
                <meta name="twitter:site" content="@ellitoral" />
                <meta name="twitter:creator" content="@ellitoral" />
                <meta property="twitter:title" content={title}/>
                <meta property="twitter:description" content={summaryWithoutHtml}/>
                <meta property="twitter:url" content={'https://www.ellitoral.com' + url}/>
                {!isLiveBlogs && <link rel="amphtml" href={'https://www.ellitoral.com' + ampUrl} />}
                <link rel="image_src" href={!relatedImages.imgUrl ? metaImageDefault : relatedImages.domain + relatedImages.imgUrl} />
                <link rel="canonical" href={process.env.NEXT_PUBLIC_DOMAIN_URL + url} />
                <meta name="robots" content="max-image-preview:large" />
                <meta name="article:section" content={sectionsUrlArray && sectionsUrlArray.length > 0 ? sectionsUrlArray[sectionsUrlArray.length - 1] : '' } />
                <meta name="article:published_time" content={zuluPublishedDate ?? ''} />
                <meta name="article:modified_time" content = {zuluModificatedAt ?? ''} />
                <meta name="article:location" content="region:arg" />
                <meta name="article:opinion" content={ (sectionUrl == '/seccion/opinion').toString() } /> 
                <meta name="DC.date.issued" content={zuluPublishedDate ?? ''} /> 
                <meta name="date" content={zuluPublishedDate ?? ''} /> 
                <meta name="distribution" content="global" />
                {tags && tags.map((tag, index) => {
			    		return <meta name="article:tag" content={tag.name} key={"tag" + index}/>
			    	})}       
            </Head>

            <Ldjson props={props.content} domain={'https://www.ellitoral.com'} summary={summaryWithoutHtml} url={process.env.NEXT_PUBLIC_DOMAIN_URL + url} related_image_url={relatedImages.domain + relatedImages.imgUrl} authors={authors} sections={sections} sectionUrl={sectionUrl} isLiveBlogs={isLiveBlogs} />

            {body && <LdJsonLiveblogs 
                newsData = {{
                    publishedDate,
                    lastModified,                
                    title,
                    subtitle,
                    summary,
                    body,
                    sections,
                    authors,    
                    url: process.env.NEXT_PUBLIC_DOMAIN_URL + url,
                    related_image_url: relatedImages.domain + relatedImages.imgUrl,
                    sectionUrl
                }}            
            />}
             <Script
                src='https://ejs.mowplayer.com/js/player/mT8l9EiUid.js'
                strategy="afterInteractive"
            />

            <Script
                src='https://connect.facebook.net/es_LA/sdk.js#xfbml=1&version=v13.0'
                nonce="M21eD7Vg"
                strategy="afterInteractive"
            />
            
            <Chartbeat sections={sections} authors={authors} />
            <Header menues={menues} isOpenSidePanel={(open) => setOpen(open)} proviImage={relatedImages.domain + relatedImages.imgUrl} />
            <div className={`${styles["parent"]}`}>
                <div className={`${styles['main-container']}`}>
                    <div className={"article"}>
                        <hr className={`${styles["article-container-hr"]}`} />
                        <div className={`${styles["article-container-title"]}`}>
                            <Nameplate sections={sections} subtitle={subtitle} title={title} summary={summary} sectionUrl={sectionUrl} isLiveBlogs={isLiveBlogs} />
                            {
                                image
                                    ? <div className={`${styles["container-article-image"]}`} onClick={imagesGallery.length !== 0 ? () => handleClickImage(0) : null} >
                                        {Pagegrowler.getLilanewsRelatedContent(related, RELATED_PROPS, `${styles['article-image-epi']}`)}
                                        <span className={styles["img-expand"]}>
                                            <button className={styles["open-img"]} aria-label="Open Image">
                                                <ExpandImage />
                                            </button>
                                        </span>
                                    </div>
                                    : ''
                            }
                            <hr />
                            <div className={`${styles["grid-container"]}`}>
                                <div className={`${styles["detail-left"]}`}>
                                    <div id={`cuerpo-de-nota`} className={`${styles['dynamic-content']}`}>
                                        {metadata && metadata.sponsored && (
                                            <div className={`${styles["sponsored-content"]}`}>
                                                <h3>contenido <strong>patrocinado</strong></h3>
                                            </div>
                                        )}

                                        {/* Time update */}
                                        <div className={`${styles["dates-container"]} ${styles["paragraph-detail"]}`}>
                                            <DateTimeUpdateComponent publishedDate={zuluPublishedDate} 
                                                                     publishedMonthDayYear={publishedMonthDayYear} 
                                                                     modificatedMonthDayYear={modificatedMonthDayYear} 
                                                                     modificatedAt={isModifiedAfterPublish ? zuluModificatedAt : zuluPublishedDate} 
                                                                     publishedTimeHour={publishedTimeHour}
                                                                     modificatedTimeHour={modificatedTimeHour}/>
                                        </div>

                                        {/* Social links */}
                                        <div className={`${styles["paragraph-detail"]}`}>
                                            <SocialLinks url={url} />
                                        </div>

                                        {/* Autores */}
                                        {authors && (
                                            <div className={`${styles["author-container"]} ${styles["paragraph-detail"]}`}>
                                                <div className={`${styles["author-box-container"]}`}>
                                                    <span className={`${styles["author-por"]}`}>Por:&nbsp;</span> 
                                                    {authors.map((author, index) => (
                                                        <Fragment key={'author' + index}>
                                                            <Author author={author} />
                                                        </Fragment>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {imagesGallery.length !== 0 &&
                                            <Slider
                                                imageUrls={imagesGallery}
                                                isOpen={showSlider}
                                                arrowLeft={'<'}
                                                arrowRight={'>'}
                                                currentSlide={currentSlide}
                                                onClose={() => handleCloseSlider()}
                                            />
                                        }

                                        {/* Lilanews content */}
                                        {content && content.map((element, index) => {
                                            return (
                                                <Fragment key={'content' + index} >
                                                    {element.type === 'image' && imagesGallery.length !== 0
                                                        ? (
                                                            <div className={styles["img-container"]} onClick={() => handleClickImage(element.component.props.paragraph._id)}>
                                                                {element.component}
                                                            </div>
                                                        )
                                                        : (
                                                            element.component
                                                        )}
                                                </Fragment>
                                            );
                                        })}

                                        {relatedDataFactory && relatedDataFactory[0] && relatedDataFactory[0].type && (
                                            <div>
                                                <DataFactory
                                                    content={relatedDataFactory[0].value}
                                                    type={typeDatafactory}
                                                />
                                            </div>
                                        )}

                                        <div id="fin_cuerpo" className={styles['fin-de-nota']} />

                                        {metadata && metadata.canHaveComments && metadata.canHaveComments == true && (
                                            <div className={`${styles['widget-block']}`}>
                                                <div className={`${styles['top-fb-comments']}`}>
                                                    <h4>Dejanos tu comentario</h4>
                                                    <hr />
                                                    <p>Los comentarios realizados son de exclusiva responsabilidad de sus autores y las consecuencias derivadas de ellos pueden ser pasibles de las sanciones legales que correspondan. Evitar comentarios ofensivos o que no respondan al tema abordado en la informaciÃ³n.</p>
                                                </div>
                   			    </div>
					)}
                                        {(metadata && metadata.canHaveComments && metadata.canHaveComments == true) && (!process.env.NODE_ENV || process.env.NODE_ENV === 'production') &&
                                            <>
                                                <div id="fb-root" />
                                                <div className={`${styles['fb-container']}`}>
                                                    <div
                                                        className={`fb-comments ${styles['fb-comments']}`}
                                                        data-colorscheme="light"
                                                        data-num-posts="10"
                                                        data-width="100%"
                                                        data-href={'https://www.ellitoral.com' + url}
                                                    />
                                                </div>
                                            </>
                                        }
                                    </div>

                                    {/* Social links */}
                                    <div className={`${styles['social-mobile']}`}>
                                        <SocialLinks url={url} />
                                    </div>

                                    {tags && tags.length > 0 && (
                                        <>
                                            <div className={`${styles['temas-container']}`}>
                                                <div className={`${styles['temas-title']}`}>
                                                    #TEMAS:
                                                </div>
                                                <div className={`${styles['temas-tags']}`}>
                                                    {tags.map((element, index) => (
                                                        <div
                                                            key={'tags' + index}
                                                            className={handleStyles(index)}
                                                        >
                                                            <a href={`/tags/${element.slug}`}>{element.name}</a>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    <AdemasTenesQueLeer relatedNews={relatedNews} parentId={_id} />

                                    {widgets['AdemasTenes'] && <AdemasTenes {...widgets['AdemasTenes']} />}

                                </div>

                                <div className={`${styles["detail-right"]}`}>
                                    <PagegrowlerList url='column-lilanews'/>
                                </div>

                            </div>
                            <div className={`${styles["detail-full"]} tags-list`}>
                                {!props.preview && <Templates.BannerHorizontalChico bannerId={`horizontal1`} />}
                                <div className={`${styles['widget-block']}`}>
                                    {components && (
                                        components.map((component, index) => {
                                            if (component.position === 'bottom' && component.name === 'TePuedeInteresar') {
                                                const TargetComponent = Templates['TePuedeInteresar']
                                                const data = component
                                                return <TargetComponent {...data} key={index} limitMd={3} limitSm={2} />
                                            }
                                        })
                                    )}
                                </div>

                                <div className={`${styles['widget-block']}`}>
                                    <div className={`${styles['column-widget-container-parent']}`}>
                                        {components && (
                                            components.map((component, index) => {
                                                if (component.position === 'bottom' && component.name === 'UltimasDeSecciones') {
                                                    const TargetComponent = Templates['UltimasDeSecciones']
                                                    const data = component
                                                    return <TargetComponent {...data} key={index} />
                                                }
                                            })
                                        )}
                                    </div>
                                </div>
                                {!props.preview && <Templates.BannerHorizontalGrande bannerId={`horizontal2`} />}

                            </div>
                        </div>
                    </div>
                    <div className={`${styles["parent-right"]}`} />
                </div>
            </div>
            <div style={{ clear: "both" }}>
                <Footer />
                {!props.preview && <MegaBannerDerecha customId={`lateralmega`} />}
            </div>
        </>
    );
}

export default Nota;
